import React from 'react';
import PropTypes from 'prop-types';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock as farFaClock } from '@fortawesome/free-regular-svg-icons';

import 'Components/Blog/cards/BlogPostsCard.scss';
import BlogCardLabel from 'Components/Blog/cards/BlogCardLabel';
import store from 'Redux/store';


const BlogPostsCard = ({
  post,
  showDate,
  darkTheme,
  hideIntro,
  showLabel,
  clickTrackingSection,
  blogCardNameTag,
}) => {
  if (isEmpty(post)) return false;

  const title = get(post, 'data.title[0].text', '');
  const created = get(post, 'data.publication_datetime', '');
  const introText = get(post, 'data.intro_text[0].text', '');
  const image = get(post, 'data.cover');
  const category = get(post, 'data.category') || 'Games';

  const onLinkClick = (link) => {
    if (clickTrackingSection !== '') {
      store.dispatch({
        type: 'frontend/click/CLICK_INTERACTION',
        payload: { section: clickTrackingSection, value: link },
      });
    }
  };

  const srcSet = [];

  const smallUrl = get(image, '224x126.url');
  const smallWidth = get(image, '224x126.dimensions.width');
  const mediumUrl = get(image, '400x225.url');
  const mediumWidth = get(image, '400x225.dimensions.width');
  const largeUrl = get(image, '752x423.url');
  const largeWidth = get(image, '752x423.dimensions.width');

  const originalWidth = get(image, 'dimensions.width');

  if (originalWidth) {
    srcSet.push(`${image.url} ${originalWidth}w`);
  }

  if (largeUrl && largeWidth) {
    srcSet.push(`${largeUrl} ${largeWidth}w`);
  }
  if (mediumUrl && mediumWidth) {
    srcSet.push(`${mediumUrl} ${mediumWidth}w`);
  }
  if (smallUrl && smallWidth) {
    srcSet.push(`${smallUrl} ${smallWidth}w`);
  }

  const formattedDate = distanceInWordsToNow(
    created,
    { addSuffix: true },
  );

  const TagName = blogCardNameTag;

  return (
    <article
      className={classNames(
        'blog-post-card',
        { 'short-card': hideIntro },
        { 'card-dark-theme': darkTheme },
      )}
    >
      <Link to={`/blog/${post.uid}`} className="w-100" onClick={() => onLinkClick(`/blog/${post.uid}`)} >
        {showLabel && <BlogCardLabel category={category} />}
        <div className="responsive-image responsive-image--16by9 blog-img-container">
          <img
            className="img-fluid blog-card-img img-full img-force-full"
            srcSet={srcSet.join(', ')}
            sizes="(min-width: 1520px) 420px, (min-width: 1200px) 356px, (min-width: 992px) 300px, (min-width: 768px) 340px, (min-width: 576px) 524px, 95vw"
            src={image.url}
            alt={title}
            loading="lazy"
          />
        </div>
        <div className="blog-post-card-container p-3">
          <div>
            <TagName className="blog-card-title">
              {title && title}
            </TagName>
          </div>
          {!hideIntro &&
            <div>
              <p className="blog-card-intro-text">
                {!isEmpty(introText) && introText}
              </p>
            </div>
          }
        </div>
        {!hideIntro &&
          <hr className="blog-card-hr mx-3 my-0" />
        }
        {showDate &&
          <div
            className={classNames(
              'blog-card-date',
              { 'pt-0': hideIntro },
            )}
          >
            <FontAwesomeIcon icon={farFaClock} className="mr-1" />
            Posted {formattedDate}
          </div>
        }
      </Link>
    </article>
  );
};

BlogPostsCard.propTypes = {
  post: PropTypes.shape({}),
  showDate: PropTypes.bool,
  darkTheme: PropTypes.bool,
  hideIntro: PropTypes.bool,
  showLabel: PropTypes.bool,
  clickTrackingSection: PropTypes.string,
  blogCardNameTag: PropTypes.string,
};

BlogPostsCard.defaultProps = {
  post: {},
  showDate: true,
  darkTheme: false,
  hideIntro: false,
  showLabel: false,
  clickTrackingSection: '',
  blogCardNameTag: 'h4',
};

export default BlogPostsCard;
